import React, { useEffect } from "react";
import styled from "styled-components";

// components
import {
  Button,
  StyledText,
  Span,
  TextInput,
  CurveHolder,
} from "../../components/common/basic";

// assest
// import loginheader from "../../../../public/assets/images/dev/loginheader.jpg";
import { Curve } from "../../components/svgs";

// hooks
import { useAuth } from "../../hooks/";

const VerifyOTP = () => {
  const {
    verifyCode,
    phoneNumber,
    OTPNumberError,
    OTPLoading,
    resendOTPCode,
    setLoginState,
    setOTPCode,
    expiryOTPCountdown,
    setExpiryOTPCountdown,
    getExpiryOTPCountdown,
  } = useAuth();

  useEffect(() => {
    if (!expiryOTPCountdown) return;
    const intervalHandler = setInterval(() => {
      setExpiryOTPCountdown(expiryOTPCountdown - 1);
    }, 1000);
    return () => clearInterval(intervalHandler);
  }, [expiryOTPCountdown]);

  useEffect(() => {
    getExpiryOTPCountdown();
  }, []);

  return (
    <MainHolder>
      {/* <Image src={loginheader} /> */}
      <CurveHolder>
        <Curve />
      </CurveHolder>
      <InputSection>
        <StyledText height={35} margin={0} fontFamily={600} size={24}>
          Enter OTP
        </StyledText>
        <StyledText height={20} size={14} fontFamily={300} margin={0}>
          An OTP has been sent to
          <Span height={20} size={14} margin={0} fontFamily={700}>
            {` ${phoneNumber}`}
          </Span>
        </StyledText>
        <StyledText height={20} size={14} fontFamily={300} margin={0}>
          Wrong number?
          <Span
            onClick={() => {
              localStorage.removeItem("sentCode");

              setLoginState("LoginScreen");
            }}
            color={"#e31c79"}
            height={20}
            size={14}
            margin={0}
            fontFamily={700}
          >
            {" Change it"}
          </Span>
        </StyledText>
        <TextInput
          hasError={OTPNumberError}
          placeholder={"OPT Code"}
          hasIcon={false}
          marginTop={20}
          cb={(value) => {
            const code = value.replace(/[^0-9.]/g, "");

            setOTPCode(code);
          }}
        />
        {OTPNumberError && (
          <StyledText color={"#e31c79"} margin={0} align={"center"} size={11}>
            Error! Try Again
          </StyledText>
        )}
        <div style={{ marginTop: 15 }}>
          <StyledText height={18} size={14} fontFamily={300} margin={0}>
            Expires in
            <Span
              color={"#e31c79"}
              height={18}
              size={14}
              margin={0}
              fontFamily={700}
            >
              {expiryOTPCountdown === 60 ? " 1:00" : ` 0:${expiryOTPCountdown}`}
            </Span>
          </StyledText>
          <StyledText height={18} size={14} fontFamily={300} margin={0}>
            Did not receive OTP?
            <Span
              color={expiryOTPCountdown > 0 ? "#C8CBCB" : "#e31c79"}
              height={18}
              size={14}
              margin={0}
              fontFamily={700}
              onClick={() => {
                if (expiryOTPCountdown <= 0) resendOTPCode();
              }}
            >
              {" Resend"}
            </Span>
          </StyledText>
        </div>
        <ButtonHolder>
          <Button
            disabled={OTPLoading}
            margin={10}
            onClick={() => {
              if (!OTPLoading) verifyCode();
            }}
          >
            <StyledText color={"white"}>
              {OTPLoading ? "Loading..." : "Next"}
            </StyledText>
          </Button>
        </ButtonHolder>
      </InputSection>
    </MainHolder>
  );
};

const MainHolder = styled.div`
  display: grid;
  align-content: space-between;
  grid-template-rows: auto auto 1fr;
  overflow: hidden;
  height: 700px;
  @media screen and (max-width: 480px) {
    border-radius: 0px;
    padding-bottom: 5px;
    height: 100vh;
  }
`;

const Image = styled.img`
  height: 300px;
  width: 100%;
`;

const InputSection = styled.div`
  display: grid;
  grid-template-rows: auto auto auto auto auto 1fr;
  padding: 15px;
  margin-top: -20px;
  background-color: white;
`;

const ButtonHolder = styled.div`
  display: grid;
  align-content: center;
`;

export default VerifyOTP;
